'use client';

import { type FC } from 'react';
import { SegmentedControl } from '../../../ui';
import type { RushMidTab } from '../RushMidGame';
import { useLocalTranslation } from '../../../../hooks/useLocalTranslation';
import translations from '../RushMid.translations';

interface RushMidTabsProps {
  activeTab: RushMidTab;
  onChange: (tab: RushMidTab) => void;
}

export const RushMidTabs: FC<RushMidTabsProps> = ({ activeTab, onChange }) => {
  const { t } = useLocalTranslation(translations);
  return (
    <div data-sound="ring">
      <SegmentedControl
        segments={[{ id: 'games', label: t('gamesTab') }, { id: 'fighter', label: t('tabFighter') }, { id: 'history', label: t('history') }, { id: 'rating', label: t('ratingTab') }, { id: 'raffle', label: t('raffleTab') }]}
        value={activeTab}
        onChange={onChange}
        className="px-4 py-2"
      />
    </div>
  );
};
